import Appointment from "./Appointment/Routes";
import PartOne from "./PartOne/Daily/Routes";
import CoyTransPartOne from "./PartOne/CompanyTransfer/Routes";

export default [...Appointment, ...PartOne, ...CoyTransPartOne];
